import styled from 'styled-components';

interface VariantProps {
  variant: string;
}

const getColorByVariant = (variant: string) => {
  if (variant.includes('A')) return '#28A745';
  if (variant.includes('B')) return '#22979A';
  if (variant.includes('C')) return '#960A0A';
  return '#520D0D';
};

export const Container = styled.div`
  .summary-capag-badge {
    border-radius: 8px;
    color: #fff;
    height: 7.625rem;
    min-width: 8.125rem;
    padding: 1.375rem 1.25rem;
  }

  .summary-capag-badge-title {
    font-size: 0.9375rem;
    font-weight: 700;
    line-height: 1.2;
  }

  .summary-capag-badge-value {
    font-size: 1.875rem;
    font-weight: 700;
    line-height: 1;
  }

  .summary-capag-indicators {
    background: #eaeced;
    border-radius: 10px;
    min-height: 7.625rem;
    padding: 0.375rem 0.875rem;
  }

  .summary-capag-indicator-row {
    min-height: 2.25rem;
  }

  .summary-capag-indicator-label {
    color: #000;
    font-size: 0.6875rem;
    font-weight: 700;
  }

  .summary-capag-text {
    color: #000;
    font-size: 0.875rem;
    line-height: 1.15;
  }

  @media only screen and (max-width: 768px) {
    .summary-capag-content {
      flex-direction: column;
    }

    .summary-capag-badge {
      height: auto;
      min-width: 100%;
    }
  }
`;

export const CapagBadge = styled.div<VariantProps>`
  background-color: ${({ variant }) => getColorByVariant(variant)};
`;

export const CapagIndicatorValue = styled.div<VariantProps>`
  background-color: ${({ variant }) => getColorByVariant(variant)};
  color: #fff;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1.15;
  min-width: 9.75rem;
  padding: 0.1875rem 0.75rem;
  text-align: center;

  @media only screen and (max-width: 768px) {
    min-width: 6.5rem;
  }
`;
